import { ChangeDetectorRef, Component, HostListener, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { Constant } from './constant/constant';
import { AccessSetService } from './services/access-set.service';
import { LoginService } from './services/login.service';
import { WebsocketService } from './services/websocket.service';
import { MatDialog } from '@angular/material/dialog';
import { OrderReceivedPopupComponent } from './shared/order-received-popup/order-received-popup.component';
import { ReminderPopupComponent } from './shared/reminder-popup/reminder-popup.component';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { Router, NavigationEnd } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SubscriptionsService } from './services/subscriptions.service';
import { RestrictionComponent } from './pages/renewal/restriction/restriction.component';
import { CountryLocationService } from './services/country-location.service';
import { FirebaseMessagingService } from 'src/app/services/firebase-messaging.service';
import { ConversationPopupComponent } from './shared/conversation-popup/conversation-popup.component';
import { EcryptServiceService } from './services/ecrypt-service.service';
import { TrackClickDirectiveService } from './services/track-click-directive.service';
import { GuideService } from './services/guide.service';
import { GoogleAdsAttributionService } from './services/google-ads-attribution.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private readonly subscriptionPlanSelectionRoute = '/subscription/plan-selection';
  private readonly TRIAL_CACHE_REFRESH_INTERVAL_MS = 60 * 60 * 1000;

  url = '';
  private destroy$ = new Subject<void>();
  private resizeSubject = new Subject<number>();
  private timeUpdateInterval: any;

  chatAiType: any = 0;

  taskType: any;
  audioType: number;
  trackingEnabled: boolean = false;

  constructor(private accessSetService: AccessSetService,
    public websocket: WebsocketService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    public crmsetting: CrmsettingsService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private subscriptionsService: SubscriptionsService,
    private countryLocationService: CountryLocationService,
    private messagingService: FirebaseMessagingService,
    private ecryptService: EcryptServiceService,
    private trackClickDirectiveService: TrackClickDirectiveService,
    public guideService: GuideService,
    private googleAdsAttributionService: GoogleAdsAttributionService
  ) {
    this.matIconRegistry.addSvgIcon(
      "lead-attribute",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/lead-attribute.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-attribute-set",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/lead-attribute-set.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "activity-due",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/activity-due.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "activity-incoming",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/activity-incoming.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "follow-activity-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/follow-activity-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-call-record-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-call-record-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-call-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-call-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-city-wise",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-city-wise.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-customer-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-customer-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-formid-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-formid-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-product-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-product-report.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "lead-source-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-source-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-state-wise",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-state-wise.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-status-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-status-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-type-wise",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-type-wise.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-user-formid-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-user-formid-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-user-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/lead-user-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "user-call-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/user-call-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "user-wise-source-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/user-wise-source-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "user-wise-status-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/crm-reports-icons/user-wise-status-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "deals-attribute-set",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/deals-attribute-icons/deals-attribute-set.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "deals-attributes",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/deals-attribute-icons/deals-attributes.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "contact-attributes",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/contact-attribute-icons/contact-attributes.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "contact-attribute-set",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/contact-attribute-icons/contact-attribute-set.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "calendar-crm",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/calender.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "lead-scoring",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/lead-scoring.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-status",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/lead-status.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "deal_stage",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/deal_stage.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "distributer",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/distributer.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-activity-list",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/lead-activity-list.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pipe_line",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/pipe_line.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "plans",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/plans.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "source_status_report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/source_status_report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-source-integration",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/other-crm-icons/lead-source-integration.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "task",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/task.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "user-attendance-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/user-attendance-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "designation",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/designation.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "department",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/department.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "appointments",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/appointments.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "client-list",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/client-list.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "page-list-one",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/page-list-one.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "page-lists",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/page-lists.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "roles",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/roles.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "support-ticket",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/support-ticket.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "accounts",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/accounts.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Appraisal",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/Appraisal.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "automation",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/automation.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "complains",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/complains.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "discussions",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/discussions.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Employees",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/Employees.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "expense-categories",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/expense-categories.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Holidays",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/Holidays.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "leave-approval",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/leave-approval.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "leave-request",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/leave-request.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Notes",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/Notes.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Notice",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/Notice.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Policy",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/Policy.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "deal-status",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/deal-status.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lead-source-integration",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/lead-source-integration.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "payment-subscription",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/payment-subscription.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "registration",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/registration.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "status",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/status.svg")
    );



    this.matIconRegistry.addSvgIcon(
      "customer-tax-rules",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/customer-tax-rules.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "credit-memos",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/credit-memos.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Customer",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Customer.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "goods-recieved",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/goods-recieved.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Invoices",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Invoices.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "manage-tax-rules",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/manage-tax-rules.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "manage-tax-zone-rates",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/manage-tax-zone-rates.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "my-appointments",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/my-appointments.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Orders",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Orders.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "out-of-stock-notification",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/out-of-stock-notification.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "product-tax-class",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/product-tax-class.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Purchase",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Purchase.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Quotations",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Quotations.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "Return",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Return.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "sales-order",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/sales-order.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Sales",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Sales.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Shipments",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Shipments.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Technician",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Technician.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "transaction-history",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/transaction-history.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Transfers",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/sales-icons/Transfers.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "calculatedby",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/calculatedby.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "delivery-slots",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/delivery-slots.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "dinner-table",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/dinner-table.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "gift-cards",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/gift-cards.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "gold-group",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/gold-group.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "gold-items",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/gold-items.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "gold-live-rate",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/gold-live-rate.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "gold-loan-customer",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/gold-loan-customer.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "gold-loan-receipt",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/gold-loan-receipt.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "interest-type",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/interest-type.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "lecture",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/lecture.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "loan-type",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/loan-type.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "manage-attributes-set",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/manage-attributes-set.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "manage-attributes",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/manage-attributes.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "manage-categories",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/manage-categories.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "manage-products",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/manage-products.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "order-slab",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/manage-products.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pos-category",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/pos-category.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pos-supplier",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/pos-supplier.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "product-listing",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/product-listing.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "product",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/product.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "production",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/production.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "quantity-adjustments",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/quantity-adjustments.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "referral-product",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/referral-product.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "referral",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/referral.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "reviews-ratings",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/reviews-ratings.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "search-tearms",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/search-tearms.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "size-chart",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/size-chart.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Specification",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/Specification.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "stock-count",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/stock-count.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "supplier-discount",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/supplier-discount.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "supplier-registration",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/supplier-registration.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "supplier",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/supplier.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "tax-rate",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/tax-rate.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "technician-rule",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/catalog-icons/technician-rule.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Cuisines",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/Cuisines.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "customer-role",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/customer-role.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "manage-customer",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/manage-customer.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "partner-store-details",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/partner-store-details.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Partner",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/Partner.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "POS-user",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/POS-user.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Profile",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/Profile.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "referral-customer",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/referral-customer.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "shopping-cart-price-rule",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/customers-icons/shopping-cart-price-rule.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "grid",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/settings-icons/grid.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "course-history-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/settings-icons/course-history-icon.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "common_settings",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/settings-icons/common_settings.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "customer-access-set",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/settings-icons/customer-access-set.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "system-configuration",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/settings-icons/system-configuration.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "deal-status",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/settings-icons/deal-status.svg")
    );

    //New Icons for CMS

    this.matIconRegistry.addSvgIcon(
      "blog-section",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/blog-section.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "blog",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/blog.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "broucher",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/broucher.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "contact-us",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/contact-us.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "contact",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/contact.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "customer-product-scope",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/customer-product-scope.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "dynamic-form-group",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/dynamic-form-group.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "dynamic-form-label",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/dynamic-form-label.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "footer",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/footer.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "form-submission",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/form-submission.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "layout",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/layout.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pages",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/pages.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "partner-data",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/partner-data.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "seo",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/seo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "show-location",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/show-location.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "subscription-form",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/subscription-form.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "subscription",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/cms-icons/subscription.svg")
    );

    //for hr Icons

    this.matIconRegistry.addSvgIcon(
      "task-attribute-set",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/task-attribute-set.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "task-attribute",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/hr-icons/task-attribute.svg")
    );

    //for Medical Icoons


    this.matIconRegistry.addSvgIcon(
      "medical-attribute-option",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/medical-icons/medical-attribute-option.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "patient-attribute-set",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/medical-icons/patient-attribute-set.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "patient-attributes",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/medical-icons/patient-attributes.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "patient",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/medical-icons/patient.svg")
    );

    //report icons

    this.matIconRegistry.addSvgIcon(
      "course-item-history-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/course-item-history-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "custom-form-submission",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/custom-form-submission.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "lead-score-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/lead-score-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "product-qty-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/product-qty-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "referal-otherwise-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/referal-otherwise-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "referral-order-item",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/referral-order-item.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "supplier-commission-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/supplier-commission-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "supplier-payment-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/supplier-payment-report.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "tax-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/tax-report.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "today-leadscoring-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/today-leadscoring-report.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "transaction-history-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/transaction-history-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "user-coupon-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/report-icons/user-coupon-report.svg")
    );

    //system icons

    this.matIconRegistry.addSvgIcon(
      "currencies",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/currencies.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "currency",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/currency.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "delivery-country",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/delivery-country.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "expense-country",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/expense-country.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "language",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/language.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "payment-mode",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/payment-mode.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pincode",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/pincode.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pos-setting",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/pos-setting.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pos-warehouse",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/pos-warehouse.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "shipping-table-report",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/shipping-table-report.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "translate",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/translate.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "warehouse",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/warehouse.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "newsletter-subscription",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/system-icons/newsletter-subscription.svg")
    );

    this.getAllCrmData();
    this.initWebsocket();
    this.url = this.router.url;
  }

  checkfreeTrial() {
    this.subscriptionsService.checkFreeTrail()
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          try {
            if (data != null) {
              const msg = this.subscriptionsService.getSubscriptionMessage(data);
              this.subscriptionsService.updateTrialExpiredMessage(msg);

              const cacheObj: any = {
                expiryDate: data?.trailExipryDate,
                isExpired: String(msg || '').toLowerCase().includes('expired'),
                msg: msg,
                lastChecked: new Date().toISOString()
              };
              this.setTrialCache(cacheObj);

              if (cacheObj.isExpired) {
                try {
                  this.router.navigate([this.subscriptionPlanSelectionRoute], { replaceUrl: true });
                } catch (navErr) {
                  console.warn('navigate failed', navErr);
                }
              }
            }

          } catch (e) {
            console.warn('checkfreeTrial processing failed', e);
          }
        },
        error => {
          console.error('checkfreeTrial failed', error);
        }
      );
  }

  // Read encrypted trial cache from localStorage, or null
  getTrialCache(): any | null {
    try {
      const raw = localStorage.getItem('trialExpiryData');
      if (!raw) return null;
      const decrypted = this.ecryptService.decryptionAES(raw);
      return JSON.parse(decrypted);
    } catch (e) {
      console.warn('failed to read trial cache', e);
      return null;
    }
  }

  private shouldRefreshTrialCache(cache: any | null): boolean {
    if (!cache || !cache.expiryDate || !cache.lastChecked) {
      return true;
    }

    try {
      const lastChecked = new Date(cache.lastChecked);
      if (Number.isNaN(lastChecked.getTime())) {
        return true;
      }

      const today = new Date();
      return lastChecked.getFullYear() !== today.getFullYear()
        || lastChecked.getMonth() !== today.getMonth()
        || lastChecked.getDate() !== today.getDate();
    } catch (e) {
      return true;
    }
  }

  private refreshTrialStatusIfNeeded(): void {
    const basicAuthHeaderString = this.loginService.getStorageToken(Constant.X_XSRF_TOKEN);
    if (!basicAuthHeaderString) {
      return;
    }

    try {
      const cache = this.getTrialCache();
      if (this.shouldRefreshTrialCache(cache)) {
        this.checkfreeTrial();
        return;
      }
    } catch (e) {
      console.warn('checkfreeTrial call failed', e);
    }
  }

  private scheduleTrialStatusRefresh(): void {
    if (this.timeUpdateInterval) {
      clearInterval(this.timeUpdateInterval);
    }

    this.timeUpdateInterval = setInterval(() => {
      this.refreshTrialStatusIfNeeded();
    }, this.TRIAL_CACHE_REFRESH_INTERVAL_MS);
  }

  // Write encrypted trial cache to localStorage
  setTrialCache(obj: any) {
    try {
      const encrypted = this.ecryptService.encryptionAES(JSON.stringify(obj));
      localStorage.setItem('trialExpiryData', encrypted);
    } catch (e) {
      console.warn('failed to write trial cache', e);
    }
  }

  // Returns true if cache indicates trial is expired
  isTrialExpiredFromCache(cache: any): boolean {
    try {
      if (!cache || !cache.expiryDate) return false;
      const expiry = new Date(cache.expiryDate);
      const today = new Date();
      return expiry.getTime() < today.getTime();
    } catch (e) {
      return false;
    }
  }

  countryCode: any;

  plan: any;

  stopRecordingAndReturn() {
    const ctx = this.guideService.activeRecordingContext;
    this.guideService.stopRecording();
    if (ctx && ctx.route) {
      this.router.navigateByUrl(ctx.route);
    }
  }

  confirmAction(action: 'click' | 'none') {
    this.guideService.confirmCapturedStep(action);
  }

  discardCapture() {
    this.guideService.discardPendingStep();
  }

  private currentUtterance: SpeechSynthesisUtterance | null = null;

  ngOnInit() {
    this.googleAdsAttributionService.initializeCapture();

    if ('speechSynthesis' in window) {
      window.speechSynthesis.getVoices();
    }

    this.plan = localStorage.getItem('plan');

    this.resizeSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe(width => {
        if (width !== this.previousWidth) {
          this.previousWidth = width;
          // Only update what's necessary, avoid forcing change detection
        }
      });

    let basicAuthHeaderString = '';

    if (Constant.DEVICE_TYPE == "MOBILE") {
      basicAuthHeaderString = this.loginService.getStorageToken(
        Constant.X_XSRF_TOKEN
      );
    } else {
      basicAuthHeaderString = this.loginService.getStorageToken(
        Constant.X_XSRF_TOKEN
      );
    }

    if (basicAuthHeaderString != null && basicAuthHeaderString != undefined && basicAuthHeaderString != "") {

      this.trackingEnabled = true;
      this.redirectToPlanSelectionIfNeeded();

    }

    this.url = this.router.url;
    if (basicAuthHeaderString != null) {
      this.refreshTrialStatusIfNeeded();
      this.scheduleTrialStatusRefresh();
      this.router.events
        .pipe(takeUntil(this.destroy$))
        .subscribe((event) => {
          if (event instanceof NavigationEnd) {
            this.refreshTrialStatusIfNeeded();
          }
        });
    }
    // Initialize global click tracking when logged in
    try {
      this.trackClickDirectiveService.initializeTracking();
    } catch (e) {
      console.warn('Failed to initialize tracking from AppComponent', e);
    }


    let countryData = localStorage.getItem(Constant.COUNTRY_LOCATION);

    if (countryData == null || countryData == undefined) {
      this.getUserLocationData();
    }

    this.messagingService.requestPermission();
    this.messagingService.listen();
    this.messagingService.currentMessage
      .pipe(takeUntil(this.destroy$))
      .subscribe(msg => {
        this.message = msg;
      });

  }

  message: any;
  author: any;

  getUserLocationData() {
    this.countryCode = this.countryLocationService.getCountryCode()
  }

  enableIncommingLeadPopup: any = 0;



  initWebsocket() {
    let user = null;

    if (Constant.DEVICE_TYPE != 'MOBILE') {
      user = this.loginService.getCookie(Constant.X_XSRF_TOKEN);
    } else {
      user = this.loginService.getStorageToken(Constant.X_XSRF_TOKEN);
    }


    let basic = false;
    if (user != "") {
      basic = true;
    }
    if (basic) {

      this.checkSubscriptions();

      this.accessSetService.getUserId()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res: any) => {

            let userId = res;

            if (res > 0) {
              this.websocket.initializeWebSocketConnection(userId)
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                  res => {
                    var result = res;
                  },
                );
              this.websocket.getObservableMsg()
                .pipe(takeUntil(this.destroy$))
                .subscribe((data) => {
                  try {
                    const jsonData = typeof data === 'string' ? JSON.parse(data) : data;

                    console.log("json", jsonData);

                    if (jsonData !== null && jsonData !== undefined && jsonData.type !== null && jsonData.type !== undefined) {
                      this.ngZone.run(() => {
                        const type = Number(jsonData.type);
                        if (type === 5) {
                          this.audioType = jsonData;
                          this.openDialog(jsonData);
                        } else if (type === 1) {
                          this.openDialog(jsonData);
                        } else if (type === 2) {
                          this.TransferDialog(jsonData);
                        } else if (type === 3 || type === 4) {
                          this.reminderDialog(jsonData);
                        } else if (type === 6) {
                          this.callNotes(jsonData);
                        } else if (type === 7) {
                          this.dealsreminderDialog(jsonData);
                        } else if (type === 8 || type === 9 || type === 10) {
                          this.mentionDialog(jsonData);
                        } else if (type === 11) {
                          this.customNotificationDialog(jsonData);
                        }
                      });
                    }
                  } catch (error) {
                    console.error('Error parsing JSON:', error);
                  }
                });

            }

          },
          error => {


          }
        )

    }




  }


  openDialog(data: any) {
    let dialogRef = this.dialog.open(OrderReceivedPopupComponent, {
      width: '250px',
      disableClose: true,
      data: { data: data, }
    });
    dialogRef.disableClose = true;
    const audio = new Audio();
    if (this.audioType != 5) {
      audio.src = 'assets/order-voice/lead.mp3';
    } else {
      audio.src = 'assets/order-voice/company.mp3';
    }

    audio.load();
    audio.play();
  }


  reminderDialog(data: any) {
    let dialogRef = this.dialog.open(ReminderPopupComponent, {
      width: '250px',
      disableClose: true,
      data: { data: data }
    });
    dialogRef.disableClose = true;
    const audio = new Audio();
    audio.src = 'assets/order-voice/reminder.mp3';
    audio.load();
    audio.play();
  }

  TransferDialog(data: any) {
    let dialogRef = this.dialog.open(ReminderPopupComponent, {
      width: '250px',
      disableClose: true,
      data: { data: data }
    });
    dialogRef.disableClose = true;
    const audio = new Audio();
    audio.src = 'assets/order-voice/transfer.mp3';
    audio.load();
    audio.play();
  }

  callNotes(data) {

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: {
          "activityType": 'Edit',
          "type": "lead",
          "leadId": data.leadId,
          "activityId": data.activityId,
          "leadObject": data.activity,
          "templateDisplayed": "",
          "taskSaveType": this.taskType,
          "callnoteEnable": 1,
          "callTriger": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          if (result['event'] == 'add') {
            this.reloadCurrentRoute();

          }


        });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',

        data: {
          "activityType": 'Edit',
          "type": "lead",
          "leadId": data.leadId,
          "activityId": data.activityId,
          "leadObject": data.activity,
          "templateDisplayed": "",
          "taskSaveType": this.taskType,
          "callnoteEnable": 1,
          "callTriger": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

        if (result['event'] == 'add') {
          this.reloadCurrentRoute();

        }

      });
    }


  }


  mentionDialog(data: any) {
    const mentionedBy = data.mentionedBy || 'Someone';
    const leadName = data.leadName || '';
    const notes = data.notes || '';
    const title = data.Title || 'You were mentioned in a note';
    const message = leadName
      ? `${mentionedBy} mentioned you in a note related to ${leadName}.`
      : (data.message || `${mentionedBy} mentioned you in a note.`);

    const dialogData = {
      ...data,
      Title: title,
      message: message,
      notes: notes
    };

    const dialogRef = this.dialog.open(ReminderPopupComponent, {
      width: '320px',
      disableClose: false,
      data: { data: dialogData }
    });

    const mentionMessage = `${mentionedBy} mentioned you in a note.`;

    this.speakMessage(mentionMessage);

  }



  private speakMessage(message: string) {
    if ('speechSynthesis' in window && message) {
      window.speechSynthesis.cancel();
      this.currentUtterance = new SpeechSynthesisUtterance(message);
      this.currentUtterance.lang = 'en-IN';
      this.currentUtterance.rate = 1;
      this.currentUtterance.pitch = 1;
      this.currentUtterance.volume = 1;
      window.speechSynthesis.speak(this.currentUtterance);
    }
  }


  dealsreminderDialog(data: any) {
    let dialogRef = this.dialog.open(ReminderPopupComponent, {
      width: '250px',
      disableClose: true,
      data: { data: data }
    });
    dialogRef.disableClose = true;
    const message = 'Follow up for a deal';

    this.speakMessage(message);
  }

  customNotificationDialog(data: any) {
    const title = data.Title || 'New Notification';
    const message = data.message || 'You have a new notification.';
    const notes = data.notes || '';

    const dialogData = {
      ...data,
      Title: title,
      message: message,
      notes: notes
    };

    const dialogRef = this.dialog.open(ReminderPopupComponent, {
      width: '320px',
      disableClose: false,
      data: { data: dialogData }
    });

    this.speakMessage(message);
  }

  private previousWidth: number = window.innerWidth;


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Debounce resize events to prevent excessive processing
    this.resizeSubject.next(event.target.innerWidth);
  }


  accountExits: any;

  private redirectToPlanSelectionIfNeeded() {
    this.subscriptionsService.getSubscriptionSummary()
      .pipe(take(1))
      .subscribe(
        (summary: any) => {
          if (!this.shouldRedirectToPlanSelection(summary)) {
            return;
          }

          this.router.navigate([this.subscriptionPlanSelectionRoute], { replaceUrl: true }).catch((error) => {
            console.warn('Failed to redirect to subscription plan selection', error);
          });
        },
        () => {
          // Leave routing unchanged if summary cannot be loaded.
        }
      );
  }

  private shouldRedirectToPlanSelection(summary: any): boolean {
    const mode = String(summary?.subscriptionMode || summary?.status || '').toUpperCase();
    const hasActiveSubscription = summary?.subscriptionActive === true || summary?.active === true;
    const hasTrial = summary?.trialActive === true;
    const hasSubscriptionRecord = !!(summary?.pricingId || summary?.subscriptionId || summary?.pricingName || summary?.currentPlanName);

    if (hasActiveSubscription || hasTrial) {
      return false;
    }

    if (!hasSubscriptionRecord) {
      return true;
    }

    return mode === 'EXPIRED'
      || mode === 'INACTIVE'
      || mode === 'CANCELLED'
      || mode === 'CLOSED';
  }

  checkSubscriptions() {
    this.subscriptionsService.checkSubscription()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.accountExits = data;

          if (this.accountExits != null) {
            this.router.navigate([this.subscriptionPlanSelectionRoute], { replaceUrl: true }).catch(() => {
              this.SubscriptionDialog();
            });


          } else {


          }

        },
        error => {
        }
      )
  }


  SubscriptionDialog() {
    let dialogRef = this.dialog.open(RestrictionComponent, {
      width: '350px',
      disableClose: true,
      backdropClass: 'custom-dialog-backdrop',
      hasBackdrop: true,
      data: {
        router: this.subscriptionPlanSelectionRoute,
        title: 'Plan Expired',
        discription: 'Please activate your plan to continue using the services.',
        button: 'Activate Plan'
      }
    });
    dialogRef.disableClose = true;
  }


  reload() {
    {

      this.cdr.detectChanges();
      // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      // this.router.onSameUrlNavigation = "reload";
      // this.router.navigate([this.router.url]);
    }
  }

  reloadCurrentRoute(): void {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    // Clear any intervals
    if (this.timeUpdateInterval) {
      clearInterval(this.timeUpdateInterval);
    }

    // Disconnect websocket
    if (this.websocket) {
      this.websocket.disconnect();
    }
  }

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          this.taskType = data['taskType'] || 1;

        } else {

        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }


}

